import { render, staticRenderFns } from "./transcription_skeleton.vue?vue&type=template&id=1a8f77da&scoped=true&"
import script from "./transcription_skeleton.vue?vue&type=script&lang=js&"
export * from "./transcription_skeleton.vue?vue&type=script&lang=js&"
import style0 from "./transcription_skeleton.vue?vue&type=style&index=0&id=1a8f77da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f77da",
  null
  
)

export default component.exports